import { ApolloError } from '@apollo/client';

import { useErpSurveyDetailQuery } from 'core/graphql';

import { ISurveyDetail } from './surveyModel';

interface ISurveyHook {
  survey?: ISurveyDetail;
  loading: boolean;
  error?: ApolloError;
}

/**
 * Spec 0011 — one survey template with its full question list, backing the
 * `/surveys/:id` builder page. `cache-and-network` so a template edited and
 * reopened shows the fresh structure (and the `hasResponses` lock flag) even
 * when a cached copy exists.
 */
export const useSurvey = (id?: string): ISurveyHook => {
  const { data, loading, error } = useErpSurveyDetailQuery({
    variables: { id: id || '' },
    skip: !id,
    fetchPolicy: 'cache-and-network',
  });

  return {
    survey: data?.survey ?? undefined,
    loading,
    error,
  };
};
